import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/service/auth.service';

@Injectable({ providedIn: 'root' })
export class SidebarGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  private isAllowedUrl(url: string, navs: any): boolean {
    if (!navs) return false;
    // navs may be an Array or a Set
    const items = Array.isArray(navs) ? navs : Array.from(navs as any);
    const links = items.map((i: any) => i.routerLink).filter(Boolean);
    // exact match or startsWith to handle child routes
    return links.some((link: string) => {
      if (!link) return false;
      if (url === link) return true;
      return url.startsWith(link + '/') || url.startsWith(link + '?');
    });
  }

  private checkUrl(url: string): Observable<boolean> {
    return this.authService.getSideBar().pipe(
      take(1),
      map((navs: any) => {
        const allowed = this.isAllowedUrl(url, navs);
        if (!allowed) {
          this.router.navigate(['/dashboard']);
        }
        return allowed;
      }),
      catchError(() => {
        this.router.navigate(['/dashboard']);
        return of(false);
      })
    );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkUrl(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkUrl(state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const path = route.path ? `/${route.path}` : '/';
    return this.checkUrl(path);
  }
}
